namespace TabAurous.Inventory {
    export interface MixingForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        Details: MixingDetailsEditor;
        ItemsDetails: MixingItemsEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class MixingForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.Mixing';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MixingForm.init)  {
                MixingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = LabelEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.LookupEditor;
                var w6 = MixingDetailsEditor;
                var w7 = MixingItemsEditor;

                Q.initFormType(MixingForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'Posted', w2,
                    'AutoPosting', w3,
                    'VoucherNo', w0,
                    'VoucherTypeId', w4,
                    'UserId', w5,
                    'EmployeeId', w4,
                    'Details', w6,
                    'ItemsDetails', w7,
                    'CompanyId', w4,
                    'FinancialYearId', w4
                ]);
            }
        }
    }
}
